export class CalculatePlanETARequest {
    planId!: string;
    connectionId!: string;
}